import styled from "styled-components";


// export const DefaultStyle = createGlobalStyle`
//     *{
//     box-sizing: border-box;
//     font-family: inherit;
//     }
// `
export const WrapperKeywords = styled.div`
    width: 144px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    padding-top: 8px;
`

export const WrapperKeyword = styled.div`
    width: 144px;
    height: 23px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border : 1px solid #418ded;
    border-radius: 50px;
    margin-bottom: 3px;
`

export const KeywordSpan = styled.span`
    width: 120px;
    color: #418ded;
    font-size: 12px;
    letter-spacing: 0px;
    line-height: 16px;
    text-align: center;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/thumb_label/thumb_label.style.js